// extracted by mini-css-extract-plugin
export var chevron = "_kr-4";
export var chevronExpanded = "_kr-5";
export var row = "_kr-0";
export var rowBody = "_kr-6";
export var rowDescription = "_kr-7";
export var rowHeader = "_kr-1";
export var rowTitle = "_kr-2";
export var rowTitleComplete = "_kr-3";